export const dynamicTheme = (t = {}) => {
  const r = document.documentElement;


const favicon = document.getElementById("favicon");
if (favicon && t.windowLogo) {
  favicon.href = `/windowLogo${t.windowLogo}?v=${Date.now()}`;
  console.log("Window Logo:", favicon.href);
}


  r.style.setProperty("--navbar-bg", t.navbarBg || "#ffffff");

  r.style.setProperty("--nav-text", t.navText || "#0D59A7");
  r.style.setProperty("--nav-hover", t.navHover || "#0D59A7");
  r.style.setProperty("--nav-active-text", t.navActiveText || "#ffffff");

  r.style.setProperty("--nav-pill-bg", t.navPillBg || "#f9f9f9");
  r.style.setProperty("--nav-pill-border", t.navPillBorder || "#F0E4E4");
  r.style.setProperty("--nav-pill-radius", t.navPillRadius || "50px");

  r.style.setProperty(
    "--nav-active-bg",
    t.navActiveBg ||
      "linear-gradient(to right,#4e42b9,#653bb1,#7634a8,#842c9e,#8f2494)"
  );

  r.style.setProperty("--profile-bg", t.profileBg || "#f9f9f9");
  r.style.setProperty("--profile-text", t.profileText || "#0D59A7");

  r.style.setProperty("--logo-height", t.logoHeight || "55px");
};
